import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNDrug } from 'src/app/models/cndrug';
import { CNDrugPackage } from 'src/app/models/cndrugpackage';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';

@Component({
  selector: 'app-prescription-side',
  templateUrl: './prescription-side.component.html',
  styleUrls: ['./prescription-side.component.scss']
})
export class PrescriptionSideComponent implements OnInit {

  @Input() language = 'fr';
  @Output() entryAdded: EventEmitter<CNPrescriptionEntry> = new EventEmitter();
  @Output() entryRemoved: EventEmitter<CNPrescriptionEntry> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  selectDrugPackage(drugpackage: [CNDrug, CNDrugPackage]) {
    // From drug add a prescription
    const fields = {
      type: 'medication',
      drugindex: -1,
      itemid: 0,
      drugid: drugpackage[0].id,
      packageid: drugpackage[1].id,
      druglabel: drugpackage[0].getProperty(this.language),
//      drug,
//      drugpackage: this.item,
      packagelabel: drugpackage[1].getProperty(this.language),
      StartDate: new Date(),
      EndDate: '',
      healthagentaccess: '',
      careteamaccess: '',
      Comment: '',
      poso1: '',
      poso2: '',
      poso3: '',
      poso4: '',
      poso5: '',
      poso6: '',
      poso7: '',
      poso8: '',
      poso9: '',
      poso10: '',
      poso11: '',
      poso12: '',
      addtotreatment: true,
      weeks: '',
      days: '',
      perday: 1,
      packagenb: 1,
      showposo: false,
      risk: false,
      chronic: false,
      classification: '',
      code: ''
    };
    const fieldKeys = Object.keys(fields);
    const entry = new CNPrescriptionEntry();
    entry.value = drugpackage[1].getProperty(this.language);
    fieldKeys.forEach(aKey => {
      entry.setProperty(aKey, fields[aKey]);
    });
    this.entryAdded.emit(entry);
  }
}
